import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer'; // Asume que tienes un rootReducer configurado

const store = configureStore({
  reducer: rootReducer,
});

export default store;